import React from 'react';
import { ShieldCheckIcon, MapIcon, FileTextIcon, ArrowRightIcon, AwardIcon } from 'lucide-react';
interface LandingPageProps {
  navigate: (page: string) => void;
  t: (key: string) => string;
}
export function LandingPage({
  navigate,
  t
}: LandingPageProps) {
  return <div className="min-h-screen bg-slate-50 flex flex-col" data-id="element-423">
      <header className="bg-white border-b border-slate-200 py-4 px-4 md:px-12 flex justify-between items-center sticky top-0 z-50" data-id="element-424">
        <div className="flex items-center gap-3" data-id="element-425">
          <div className="w-10 h-10 bg-[#006A4E] rounded-lg flex items-center justify-center shrink-0" data-id="element-426">
            <MapIcon className="w-6 h-6 text-white" data-id="element-427" />
          </div>
          <div data-id="element-428">
            <h1 className="font-bold text-lg md:text-xl text-slate-900 leading-tight" data-id="element-429">
              {t('app.title')}
            </h1>
            <p className="text-[10px] md:text-xs text-slate-500 font-medium hidden sm:block" data-id="element-430">
              National Land Information Service
            </p>
          </div>
        </div>
        <button onClick={() => navigate('login')} className="bg-[#006A4E] hover:bg-[#00523c] text-white px-4 md:px-6 py-2 md:py-2.5 rounded-lg font-medium text-sm md:text-base transition-colors shadow-sm flex items-center gap-2" data-id="element-431">
          {t('landing.citizenLogin')}{' '}
          <ArrowRightIcon className="w-4 h-4 hidden sm:block" data-id="element-432" />
        </button>
      </header>

      <main className="flex-1" data-id="element-433">
        <section className="relative bg-[#006A4E] text-white overflow-hidden" data-id="element-434">
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-435"></div>
          <div className="max-w-6xl mx-auto px-6 py-16 md:py-32 relative z-10 flex flex-col md:flex-row items-center gap-12" data-id="element-436">
            <div className="flex-1 text-center md:text-left" data-id="element-437">
              <span className="inline-block py-1 px-3 rounded-full bg-white/10 border border-white/20 text-xs md:text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-438">
                Smart Bangladesh Initiative
              </span>
              <h2 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-439">
                One Owner. <br className="hidden md:block" data-id="element-440" />
                <span className="text-[#D4A843]" data-id="element-441">One Account.</span>
              </h2>
              <p className="text-base md:text-xl text-green-50 mb-8 max-w-2xl mx-auto md:mx-0 leading-relaxed" data-id="element-442">
                Access your Land Owner Certificate and manage all your
                properties across Bangladesh from a single, secure unified
                dashboard.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-443">
                <button onClick={() => navigate('login')} className="bg-white text-[#006A4E] hover:bg-slate-50 px-8 py-3.5 rounded-lg font-bold text-base md:text-lg transition-colors shadow-lg" data-id="element-444">
                  {t('landing.accessAccount')}
                </button>
                <button className="bg-transparent border border-white/30 hover:bg-white/10 text-white px-8 py-3.5 rounded-lg font-medium text-base md:text-lg transition-colors" data-id="element-445">
                  {t('landing.verifyCert')}
                </button>
              </div>
            </div>

            <div className="flex-1 w-full max-w-md relative hidden md:block" data-id="element-446">
              <div className="absolute inset-0 bg-gradient-to-tr from-[#D4A843]/20 to-transparent rounded-2xl blur-3xl" data-id="element-447"></div>
              <div className="bg-white rounded-2xl p-6 shadow-2xl relative border border-white/20 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-448">
                <div className="flex items-center gap-4 mb-6 border-b border-slate-100 pb-4" data-id="element-449">
                  <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center" data-id="element-450">
                    <ShieldCheckIcon className="w-6 h-6 text-[#006A4E]" data-id="element-451" />
                  </div>
                  <div data-id="element-452">
                    <h3 className="font-bold text-slate-800 text-left" data-id="element-453">
                      Digital Certificate
                    </h3>
                    <p className="text-sm text-slate-500" data-id="element-454">
                      Verified by Govt. of Bangladesh
                    </p>
                  </div>
                </div>
                <div className="space-y-3" data-id="element-455">
                  <div className="h-4 bg-slate-100 rounded w-3/4" data-id="element-456"></div>
                  <div className="h-4 bg-slate-100 rounded w-1/2" data-id="element-457"></div>
                  <div className="h-4 bg-slate-100 rounded w-5/6" data-id="element-458"></div>
                </div>
                <div className="mt-6 pt-4 border-t border-slate-100 flex justify-between items-center" data-id="element-459">
                  <div className="w-16 h-16 bg-slate-100 rounded-lg" data-id="element-460"></div>
                  <div className="w-24 h-8 bg-green-50 rounded-full border border-green-200 flex items-center justify-center" data-id="element-461">
                    <span className="text-xs font-bold text-green-700" data-id="element-462">
                      VALID
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-slate-50" data-id="element-463">
          <div className="max-w-6xl mx-auto px-6" data-id="element-464">
            <div className="text-center mb-12 md:mb-16" data-id="element-465">
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4" data-id="element-466">
                Transparent Land Management
              </h2>
              <p className="text-slate-600 max-w-2xl mx-auto text-sm md:text-base" data-id="element-467">
                Experience hassle-free land services with our fully digitized
                platform designed for citizens.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-468">
              <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-469">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-green-50 rounded-xl flex items-center justify-center mb-6" data-id="element-470">
                  <AwardIcon className="w-6 h-6 md:w-7 md:h-7 text-[#006A4E]" data-id="element-471" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-slate-800 mb-3" data-id="element-472">
                  Digital Certificate
                </h3>
                <p className="text-slate-600 leading-relaxed text-sm md:text-base" data-id="element-473">
                  Get your verifiable Land Owner Certificate with a unique QR
                  code. No more carrying paper documents.
                </p>
              </div>

              <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-474">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6" data-id="element-475">
                  <MapIcon className="w-6 h-6 md:w-7 md:h-7 text-blue-600" data-id="element-476" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-slate-800 mb-3" data-id="element-477">
                  Unified Account
                </h3>
                <p className="text-slate-600 leading-relaxed text-sm md:text-base" data-id="element-478">
                  View all your lands across different districts and mouzas in
                  one single dashboard automatically.
                </p>
              </div>

              <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-479">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-amber-50 rounded-xl flex items-center justify-center mb-6" data-id="element-480">
                  <FileTextIcon className="w-6 h-6 md:w-7 md:h-7 text-amber-600" data-id="element-481" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-slate-800 mb-3" data-id="element-482">
                  Online Services
                </h3>
                <p className="text-slate-600 leading-relaxed text-sm md:text-base" data-id="element-483">
                  Apply for mutation, pay land taxes, and track your
                  applications online without visiting the land office.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-slate-900 text-slate-400 py-10 md:py-12 text-center" data-id="element-484">
        <div className="max-w-6xl mx-auto px-6" data-id="element-485">
          <div className="mb-6 flex justify-center" data-id="element-486">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-slate-800 rounded-full flex items-center justify-center" data-id="element-487">
              <MapIcon className="w-5 h-5 md:w-6 md:h-6 text-slate-500" data-id="element-488" />
            </div>
          </div>
          <p className="mb-2 text-slate-300 font-medium text-sm md:text-base" data-id="element-489">
            Ministry of Land, Government of the People's Republic of Bangladesh
          </p>
          <p className="text-xs md:text-sm" data-id="element-490">
            © 2026 Smart Land Management System. All rights reserved.
          </p>
        </div>
      </footer>
    </div>;
}